<div class="formgrid grid acordion-container-card">
    <div class="col-12 md:col-12">
        <p-accordion>
            <p-accordionTab [selected]="true" header="Datos de los antecedentes" class="line-height-3 m-0">
                <div *ngIf="registro">
                    <p-table 
                        [value]="getFormDataArray()" 
                        [paginator]="false" 
                        responsiveLayout="stack" 
                        styleClass="p-datatable-gridlines" 
                        [tableStyle]="{'min-width': '50rem'}">
                        
                        <ng-template pTemplate="body" let-item>
                            <tr>
                                <td class="td-title-table-r-profesional">{{ getLabel(item.key) }}</td>
                                <td>{{ getFormattedValue(item.value) }}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>